import { render, staticRenderFns } from "./PostFilesArea.vue?vue&type=template&id=1a6558ef&scoped=true&"
import script from "./PostFilesArea.vue?vue&type=script&lang=ts&"
export * from "./PostFilesArea.vue?vue&type=script&lang=ts&"
import style0 from "./PostFilesArea.vue?vue&type=style&index=0&id=1a6558ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6558ef",
  null
  
)

export default component.exports